import { SitePage } from "../../../pages/PageNames";
import { SiteNavConfig } from "../NavigationDrawer/NavigationDrawerModels";
import {
  AgriIcon,
  DeploymentsIcon,
  HistoryIcon,
  IssuesIcon,
  SprinklersIcon,
  TrackersIcon,
  ActivityLogIcon,
  CamerasIcon,
  HomeIcon,
  LossesIcon,
  ReportsIcon,
  InvertersIcon,
} from "../../../SolarGikLib/icons/common/navigation/NavIcons";
import { isSitePageVisible } from "../NavigationUtils";
import { isMonitoringOnlyProducts } from "../../purchasedProducts/MonitorOnlySelectors";

export const NavItemsConfig: SiteNavConfig[] = [
  {
    pageName: "Home",
    pagePath: "/" + SitePage.Home,
    icon: HomeIcon,
    visibilityFilter: (filterArgs) => isSitePageVisible(SitePage.Home, filterArgs),
  },
  {
    pageName: "Losses",
    pagePath: "/" + SitePage.LossAnalysis,
    icon: LossesIcon,
    visibilityFilter: (filterArgs) => isSitePageVisible(SitePage.LossAnalysis, filterArgs),
  },
  {
    pageName: "Control",
    pagePath: "/" + SitePage.Trackers,
    icon: TrackersIcon,
    visibilityFilter: (filterArgs) => isSitePageVisible(SitePage.Trackers, filterArgs),
    getNavigationLabel: ({ siteProducts }) =>
      isMonitoringOnlyProducts(siteProducts) ? "View" : "Control",
  },
  {
    pageName: "Inverters",
    pagePath: "/" + SitePage.Inverters,
    icon: InvertersIcon,
    visibilityFilter: (filterArgs) => isSitePageVisible(SitePage.Inverters, filterArgs),
  },
  {
    pageName: "Activity Log",
    pagePath: "/" + SitePage.ActivityLog,
    icon: ActivityLogIcon,
    visibilityFilter: (filterArgs) => isSitePageVisible(SitePage.ActivityLog, filterArgs),
  },
  {
    pageName: "Agriculture",
    pagePath: "/" + SitePage.Agriculture,
    icon: AgriIcon,
    visibilityFilter: (filterArgs) => isSitePageVisible(SitePage.Agriculture, filterArgs),
  },
  {
    pageName: "Alerts",
    pagePath: "/" + SitePage.Alerts,
    icon: IssuesIcon,
    visibilityFilter: (filterArgs) => isSitePageVisible(SitePage.Alerts, filterArgs),
  },
  {
    pageName: "Faucets",
    pagePath: "/" + SitePage.Faucets,
    icon: SprinklersIcon,
    visibilityFilter: (filterArgs) => isSitePageVisible(SitePage.Faucets, filterArgs),
  },
  {
    pageName: "Cameras",
    pagePath: "/" + SitePage.Cameras,
    icon: CamerasIcon,
    visibilityFilter: (filterArgs) => isSitePageVisible(SitePage.Cameras, filterArgs),
  },
  {
    pageName: "Deployments",
    pagePath: "/" + SitePage.Deployments,
    icon: DeploymentsIcon,
    visibilityFilter: (filterArgs) => isSitePageVisible(SitePage.Deployments, filterArgs),
  },
  {
    pageName: "History",
    pagePath: "/" + SitePage.History,
    icon: HistoryIcon,
    visibilityFilter: (filterArgs) => isSitePageVisible(SitePage.History, filterArgs),
  },
  {
    pageName: "Reports",
    pagePath: "/" + SitePage.Reports,
    icon: ReportsIcon,
    visibilityFilter: (filterArgs) => isSitePageVisible(SitePage.Reports, filterArgs),
  },
];
